import { useConfirm } from 'primevue/useconfirm'

export const SAVE_IOD_CONFIRMATION_GROUP = 'save-iod-confirmation'

export function useSaveIODConfirmation() {
  const confirm = useConfirm()

  function confirmSave(folderName: string): Promise<boolean> {
    return new Promise(resolve => {
      confirm.require({
        group: SAVE_IOD_CONFIRMATION_GROUP,
        acceptLabel: `Save to ${folderName}`,
        accept: () => resolve(true),
        reject: () => resolve(false),
        onHide: () => resolve(false)
      })
    })
  }

  return { confirmSave }
}
